import { GlobalApplicationState } from 'globalApplicationState';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import { Button, DialogContent, DialogTitle, Grid, IconButton } from '@mui/material';
import { CloseIcon } from 'tinacms';
import TopicLimitedTextField from '../common/topicLimitedTextField';
import { DIALOG_BODY_PADDING, MAX_TOPIC_NAME_LENGTH } from 'modules/topics/styles/constants';
import MandatoryField from '../common/mandatoryField';
import { createTopicGroup, getTopicGroups, topicSlice } from 'modules/topics/reducer';
import { ThunkDispatch } from '@reduxjs/toolkit';

const TopicGroupCreation: React.FunctionComponent<ComponentProps> = (props) => {
    const [name, setName] = React.useState("");

    const {
        isUpdating: isSaving,
        errorMessage
    } = useSelector((state: GlobalApplicationState) => state.topics);

    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

    const handleCreation = async () => {
        if (isSaving) return;

        const isSuccessful = await dispatch(createTopicGroup(name)).unwrap();

        if (isSuccessful) {
            dispatch(getTopicGroups());
            onClose();
        }
    };

    const handleFieldChange = (name: string) => {
        setName(name);
        dispatch(topicSlice.actions.SET_ERR_MSG(""));
    }

    const getNameField = (): JSX.Element => {
        return <TopicLimitedTextField
            value={name}
            maxLength={MAX_TOPIC_NAME_LENGTH}
            onChange={handleFieldChange}
            errorText={errorMessage}
        />;
    };

    const onClose = () => {
        setName("");
        dispatch(topicSlice.actions.SET_ERR_MSG(""));
        props.onClose();
    }

    return (
        <Dialog open={props.show} maxWidth={false} scroll="paper" onClose={onClose} classes={{ paper: "audience-dialog" }}>
            <DialogTitle className="audience-dialog-title">
                Create New Topic Group
                <div className="audience-dialog-actions">
                    <IconButton onClick={onClose} size="medium">
                        <CloseIcon />
                    </IconButton>
                </div>
            </DialogTitle>
            <DialogContent className='dialog-content'>

                <Grid container
                    alignItems={"center"}
                    paddingTop={DIALOG_BODY_PADDING}
                    paddingBottom={DIALOG_BODY_PADDING}
                >
                    <MandatoryField
                        fieldName="Topic group name"
                        fieldInput={getNameField()}
                        fieldStyle={{ marginTop: "20px" }} />
                </Grid>
            </DialogContent>
            <DialogActions className="audience-dialog-footer">
                <Button variant="text" onClick={onClose}>Cancel</Button>
                <Button
                    variant="contained"
                    color="primary"
                    disabled={!name || name.trim().length === 0 || errorMessage !== ""}
                    onClick={handleCreation}
                >
                    Create
                </Button>
            </DialogActions>
        </Dialog>
    );
};

interface ComponentProps {
    show: boolean,
    onClose: () => void,
}

export default TopicGroupCreation;